module.exports = __webpack_public_path__ + "media/images/ln/horoscope_9-9d299c47b0c4c3b20b7ed019cd3824e5.png";